export default __webpack_public_path__ + "static/media/Email.a385bdb6.svg";